import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Mail } from 'lucide-react';

export const Route = createFileRoute('/admin-console/advanced/inbound-parse')({
    staticData: {
        permissions: ['admin_system:read'],
        breadcrumb: { title: 'Inbound parse' },
        ui: {
            icon: Mail,
            title: 'Inbound parse configuration',
            menuDescription: 'Manage SendGrid inbound parse settings and MX verification',
        },
    },
    component: InboundParseLayout,
});

function InboundParseLayout() {
    return (
        <PageController route={Route}>
            <Outlet />
        </PageController>
    );
}
